import { useCallback, useRef, useState } from 'react';

export default (defaultOptions = [], loadOptions) => {
  const [isFirstOpen, setFirstOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(2);
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(defaultOptions);
  const [isLastItem, setLastItem] = useState(false);

  const isInputChanging = useRef(false);

  const reset = useCallback(() => {
    setInputValue('');
    setPage(1);
    setOptions([]);
    setFirstOpen(true);
    setLastItem(false);
    isInputChanging.current = false;
  }, []);

  const onFetchSuccess = (result, isLast) => {
    // On Success
    setLastItem(isLast);
    setLoading(false);
    isInputChanging.current = false;
  };

  const onMenuScrollToBottomPaging = () => {
    if (isLastItem) {
      return;
    }

    const nextPage = page + 1;
    setLoading(true);
    setPage(nextPage);
    loadOptions && loadOptions(inputValue, setOptions, nextPage, onFetchSuccess);
  };

  const onChangeValuePaging = (string = '', actions) => {
    const { action } = actions;
    if (action === 'input-change') {
      isInputChanging.current = true;

      setOptions([]);
      setInputValue(string);
      setPage(1);
      setLoading(true);
      loadOptions && loadOptions(string, setOptions, 1, onFetchSuccess);
    }
  };

  const onMenuOpenPaging = () => {
    if (isFirstOpen && !isInputChanging.current) {
      setFirstOpen(false);
      setLoading(true);
      loadOptions && loadOptions('', setOptions, 1, onFetchSuccess);
    }
  };

  const onMenuClosePaging = () => {
    reset();
  };

  return {
    options,
    loading,
    onChangeValuePaging,
    onMenuScrollToBottomPaging,
    onMenuOpenPaging,
    onMenuClosePaging,
  };
};
